import { IpWebComponent } from '../../web-components/ip-web-component';

const numberSlider = document.createElement('template');
numberSlider.innerHTML = `
<style>
    :host {
        height: inherit;
        --slider-val: 0em;
    }
    .slider {
        height: inherit;
        overflow: hidden;
    }
    .number-group {
        height: inherit;
        transform: translateY(var(--slider-val));
    }
    .number-group-animated {
        transition: transform 2s ease-in-out;
    }
    .number {
        line-height: 1;
    }
</style>
<div class="slider">
    <div class="number-group">
        <div class="number">0</div>
        <div class="number">1</div>
        <div class="number">2</div>
        <div class="number">3</div>
        <div class="number">4</div>
        <div class="number">5</div>
        <div class="number">6</div>
        <div class="number">7</div>
        <div class="number">8</div>
        <div class="number">9</div>
    </div>
</div>
`;

class NumberSlider extends IpWebComponent {
    private numberGroupElm: HTMLElement | null = null;
    private curNum: number = 0;

    constructor() {
        super(numberSlider);
    }

    // Init component.
    connectedCallback() {
        // Set initial values.
        const initNumber = this.getPropAsNumber('init-number', 0);
        this.curNum = initNumber;
        this.numberGroupElm = this.queryUnsafe<HTMLElement>('.number-group');
        this.numberGroupElm.style.setProperty('--slider-val', `${this.curNum * -1}em`);
    }

    static get observedAttributes() {
        return ['init-number', 'number'];
    }

    attributeChangedCallback(name, _oldValue, newValue) {
        if (name === 'init-number') {
            this.curNum = parseInt(newValue, 10);
            this.numberGroupElm?.style.setProperty('--slider-val', `${this.curNum * -1}em`);
        }
        if (name === 'number') {
            const targetNum = parseInt(newValue, 10);
            this.startAnimation(targetNum);
        }
    }

    startAnimation(animateToNumber: number) {
        if (this.curNum === animateToNumber) {
            return;
        }

        const numberGroup = this.queryUnsafe<HTMLElement>('.number-group');
        numberGroup.classList.add('number-group-animated');
        numberGroup.style.setProperty('--slider-val', `${animateToNumber * -1}em`);
        this.curNum = animateToNumber;
    }
}

// Define element, if not already defined.
if (customElements.get('number-slider') === undefined) {
    customElements.define('number-slider', NumberSlider);
}
